import { ServerFetch } from '../main-model'

export default class PurchaseDepositListModel extends ServerFetch {
    getPurchaseDepositListBy = (data) => this.authFetch({
        url: 'purchase-deposit-list/getPurchaseDepositListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generatePurchaseDepositListBy = (data) => this.authFetch({
        url: 'purchase-deposit-list/generatePurchaseDepositListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}